import _ from 'lodash';
import React, {Fragment} from 'react';
import config from 'client/shared/config';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { DeleteButton } from 'client/shared/components';

import OptionsButton from './options-button';
@inject('songsStore', 'userStore', 'apiStore')
@observer
export default class SongOptions
extends React.Component {
	constructor(props) {
		super(props);
		this.state = {active: false}
	}
	render () {
		const { song, songsStore, userStore, optionsTheme = 'dark', rollover= 'true'} = this.props;
		const user = userStore.getLoggedInUser();
		const isFav = user.isHiFived(song.id);
		const subscription = user.getSubscription(song.artistID);

		return (
			<Fragment>
				{ this.renderOptions(isFav,_.isEmpty(subscription))}
			</Fragment>
		);
	}

	renderOptions (favoriteFlag, needsToSubscribe) {
		return (
			<div className="grid-x">
				{
					!needsToSubscribe &&
					this.renderListButton({
						icon: 'fal fa-arrow-to-bottom',
						label: 'Download Song',
						ariaLabel: 'download',
						onClick: this.onDownloadClick
					})
				}
				{/* {
					needsToSubscribe &&
					this.renderListButton({
						icon: 'icon fi-rss',
						label: 'Subscribe',
						ariaLabel: 'subscribe',
						onClick: this.onSubscribeClick
					})
				} */}
				{/* {
					this.renderListButton({
						icon: 'fas fa-plus',
						label: 'Add to Playlist',
						ariaLabel: 'playlist',
						// onClick: this.onRemoveHiFiveClick
					})
				} */}
				{/* {
					!favoriteFlag &&
					this.renderListButton({
						icon: 'fas fa-heart',
						label: 'Add to My Favorites',
						ariaLabel: 'favorite',
						onClick: this.onHiFiveClick
					})
				}
				{
					favoriteFlag &&
					this.renderListButton({
						icon: 'fas fa-heart-broken',
						label: 'Remove from My Favorites',
						ariaLabel: 'unfavorite',
						onClick: this.onRemoveHiFiveClick

					})
				} */}
				{/* {
					this.renderListButton({
						icon: 'fas fa-share-alt',
						label: 'Share',
						// onClick: this.onRemoveHiFiveClick
					})
				} */}
			</div>
		);
	}

	@autobind
	renderListButton ({
		icon,
		position,
		onClick,
		label,
		className = '',
		ariaLabel,
		attrs = {}
	}) {
		const {isHovered} = this.props;
		return (
			<div key={ position }>
				<button
					aria-label={ariaLabel}
					{ ...attrs }
					onClick={ onClick }
					className={ `song-row-icons ${isHovered ? 'sr-vis' : ''} button tertiary clear margin-bottom-0 ${className}` }
					style={{'fontSize': '1em'}}
				>
					<span title={label} className={ `${icon} icon` }></span> 
				</button>
			</div>
		);
	}

	@autobind
	onClick (evt) {
		const { songsStore, song } = this.props;
		songsStore.activeSongRowID = (songsStore.activeSongRowID === song.id) ? null : song.id;
		console.log("ACTIVE");
		this.setState({active: true});

		evt.stopPropagation();
	}

	@autobind
	onBlur (evt) {
		console.log("NO LONGER ACTIVE");
		
		if(!evt.relatedTarget || evt.relatedTarget.classList.contains("fa-ellipsis-v")) 
		{
			this.setState({active: false});
			return;
		}

		// else if (!evt.relatedTarget.classList.contains('button' && 'tertiary')) {
		// 	this.setState({active: false});
		// 	return;
		// }
		switch(evt.relatedTarget.ariaLabel) {
			case 'download':
				break;
			case 'subscribe':
				break;
			case 'playlist':
				break;
			case 'favorite':
				this.onHiFiveClick(evt);
				break;
			case 'unfavorite':
				this.onRemoveHiFiveClick(evt);
				break;
			case null:
				break;
		}
		// evt.stopPropagation();
	}

	@autobind onDownloadClick () {
		const {song} = this.props;
		var link=document.createElement('a');
		let path = !!song.downloadPath ? song.downloadPath : song.downLoadPath;
		link.href = path
		link.download = path.substr(path.lastIndexOf('/') + 1);
		link.click();
		// window.open(path, "_blank");
	}
	@autobind
	async onHiFiveClick (evt) {
		const { song, userStore } = this.props;
		const user = userStore.getLoggedInUser();
		const hiFiveData = await song.hiFive(user.id);
		user.hiFived.push(hiFiveData);
		// evt.stopPropagation();

	}

	@autobind
	onRemoveHiFiveClick (evt) {
		const { song, userStore, apiStore } = this.props;
		const user = userStore.getLoggedInUser();
		const { id } = _(user.hiFived).filter({ itemID: song.id }).first();
		const route = `${config.getRoute('hiFive')}/${id}`;
		apiStore.delete({ route });
		user.hiFived = _.remove(user.hiFived.slice(), { id });
		// evt.stopPropagation();
	}

	clearActiveSong () {
		this.props.songsStore.activeSongRowID = null;
	}
}
